module.exports = __webpack_public_path__ + "static/media/railofy-banner-offer.a6a26f1a.webp";